export * from './migrations/schemas.const';

export * from './migrations/v_2/centers/centers.const';
export * from './migrations/v_2/entities/entities.const';
export * from './migrations/v_2/masterdata';
export * from './migrations/v_2/permissions';
export * from './migrations/v_2/roles';

export const OTHER_LABEL = 'Other';
